<div id="recurringReport" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="table--paybee">
            <div class='text-center no-data-text' style="display: none" id="emptyRecurringList">No recurring donations yet.</div>
            <table id ="recurringList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th class="text-nowrap">First Name</th>
                    <th class="text-nowrap">Last Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Campaign</th>
                    <th>Option</th>
                    <th>Frequency</th>
                    <th>Amount</th>
                    <th>PledgeAmount</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>StartDate</th>
                    <th>EndDate</th>
                    <th>Info</th>
                    <th>InfoSelect</th>   
                    <th class="no-export"></th>                         
                </tr>
                </thead>
            </table>
        </div>
    </div>
</div>